export function formatT(value) {
    if (typeof value !== 'number') return '';
    return value.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }